import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import ContactDuplicateModel from './contact-duplicate';
import EventModel from './event';
import GoalModel from './goal';
import LineItemModel from './line-item';
import OnboardModel from './onboard';
import V2TaskModel from './v2-task';

export default class DashboardModel extends Model {
  @attr('number') declare unfinishedTasksCount: number;
  @attr('boolean') declare hasActiveJournal: boolean;

  @belongsTo('goal', { async: false, inverse: null }) declare goal?: GoalModel;
  @belongsTo('onboard', { async: false, inverse: null })
  declare onboard?: OnboardModel;
  @hasMany('line-item', { async: false, inverse: null })
  declare lineItems: LineItemModel[];
  @hasMany('event', { async: false, inverse: null })
  declare newDonors: EventModel[];
  @hasMany('event', { async: false, inverse: null })
  declare lateDonors: EventModel[];
  @hasMany('event', { async: false, inverse: null })
  declare unreadEvents: EventModel[];
  @hasMany('v2-task', { async: false, inverse: null })
  declare unfinishedTasks: V2TaskModel[];
  get unfinishedTasksArray() {
    return this.unfinishedTasks.slice();
  }
  @hasMany('contact-duplicate', { async: false, inverse: null })
  declare contactDuplicates: ContactDuplicateModel[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    dashboard: DashboardModel;
  }
}
